(() => {
  if (window.EpicIrrigationMegaVideo) return;

  window.EpicIrrigationMegaVideo = true;

  const desktopQuery = window.matchMedia('(min-width: 990px)');
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  const getCard = (target) => target.closest('[data-irrigation-mega-video]');

  const setVideoState = (card, isPlaying, isVideoVisible = isPlaying) => {
    const button = card.querySelector('.header-drawer__featured-video-toggle');
    const label = isPlaying ? 'Pause irrigation video' : 'Play irrigation video';

    card.classList.toggle('is-playing', isPlaying);
    card.classList.toggle('is-video-visible', isVideoVisible);
    button.setAttribute('aria-label', label);
    button.setAttribute('aria-pressed', String(isPlaying));
    button.querySelector('.visually-hidden').textContent = label;
  };

  const play = (card) => {
    if (!desktopQuery.matches || reducedMotionQuery.matches) return;

    const video = card.querySelector('video');
    setVideoState(card, true, true);
    video.play().catch(() => {
      setVideoState(card, false, false);
    });
  };

  const pause = (card, reset = false, keepVideoVisible = false) => {
    const video = card.querySelector('video');

    setVideoState(card, false, keepVideoVisible);
    video.pause();
    if (reset) video.currentTime = 0;
  };

  const bindCardHover = (card) => {
    if (card.dataset.irrigationMegaVideoBound === 'true') return;

    card.dataset.irrigationMegaVideoBound = 'true';
    card.addEventListener('mouseenter', () => play(card));
    card.addEventListener('mouseleave', () => pause(card, true));
  };

  const bindCardHovers = (scope = document) => {
    scope.querySelectorAll('[data-irrigation-mega-video]').forEach(bindCardHover);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bindCardHovers(), { once: true });
  } else {
    bindCardHovers();
  }

  document.addEventListener('shopify:section:load', (event) => bindCardHovers(event.target));

  document.addEventListener('focusin', (event) => {
    const card = getCard(event.target);
    if (card) play(card);
  });

  document.addEventListener('focusout', (event) => {
    const card = getCard(event.target);
    if (!card || card.contains(event.relatedTarget)) return;

    pause(card, true);
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.header-drawer__featured-video-toggle');
    if (!button || !desktopQuery.matches) return;

    event.preventDefault();
    event.stopPropagation();

    const card = getCard(button);
    const video = card.querySelector('video');

    if (video.paused) {
      setVideoState(card, true, true);
      video.play().catch(() => {
        setVideoState(card, false, false);
      });
    } else {
      pause(card, false, true);
    }
  });

  document.addEventListener('play', (event) => {
    if (event.target.matches('[data-irrigation-mega-video] video')) {
      setVideoState(getCard(event.target), true, true);
    }
  }, true);
})();
